
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/rush",
      function () {
        return require("private-next-pages/casino/rush/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/rush"])
      });
    }
  